class LoadingIndicator extends HTMLElement {
    constructor() {
        super();
        this.active = false;
    }

    static get observedAttributes() {
        return ["active"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "active") {
            this.active = newValue !== null && newValue !== "false";

            this.updateIndicator();
        }
    }

    connectedCallback() {
        this.updateIndicator();
    }

    updateIndicator() {
        this.ariaHidden = !this.active;
    }
}

customElements.define("loading-indicator", LoadingIndicator);
